module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Manage Videos")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "to": {
        name: 'VideoSeriesAddVideos',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n            Add new Video\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "to": {
        name: 'VideoSeriesOrderVideos',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n            Order Videos\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    attrs: {
      "to": {
        name: 'VideoSeriesEdit',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n            Back to General\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by Video title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_vm._m(1), _vm._v(" "), (_vm.total) ? _c('tbody', _vm._l((_vm.videos), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('img', {
      staticStyle: {
        "max-height": "150px"
      },
      attrs: {
        "src": item.thumbnail,
        "alt": item.title
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'VideoEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.detachVideo(item)
        }
      }
    }, [_vm._v("\n                      Delete\n                      "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })])], 1)])
  }), 0) : _c('tbody', [_vm._m(2)])])]), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.changePage
    }
  })], 1)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Video Series")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Thumbnail")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n                    There are no video yet. Go to 'Add New Video' to add new ones.\n                  ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2321d0f8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/content/videoSeries/ManageVideos.vue
// module id = 841
// module chunks = 0